<template>
  <span class="pip" :class="[`pip--${kind}`, { 'pip--down': signed && n < 0 }]" :title="title">
    <!-- eslint-disable-next-line vue/no-v-html -- constant art from resourceArt.js -->
    <svg class="pip__icon" viewBox="0 0 16 16" aria-hidden="true" v-html="art" />
    <span class="pip__n">{{ shown }}</span>
  </span>
</template>

<script>
import { RESOURCES, artForResource, labelFor } from './resourceArt';

// One number with the thing it counts, in the thing's own colour and shape.
export default {
  name: 'Pip',
  props: {
    kind: { type: String, required: true },
    n: { type: Number, required: true },
    // Costs read "2"; effects read "+2" / "-1".
    signed: { type: Boolean, default: false },
    // A yield that is a RANGE rather than a number: "2-4" beside the icon.
    text: { type: String, default: '' },
  },
  computed: {
    art() { return artForResource(this.kind); },
    shown() {
      if (this.text) return this.text;
      if (!this.signed) return String(this.n);
      return this.n > 0 ? `+${this.n}` : String(this.n);
    },
    title() {
      const n = Math.abs(this.n);
      const label = labelFor(this.kind, n);
      if (!this.signed) return `costs ${n} ${label}`;
      return `${this.n > 0 ? 'gains' : 'loses'} ${n} ${label}`;
    },
    colour() { return RESOURCES[this.kind]?.colour; },
  },
};
</script>
